import { combineReducers } from "redux-immutable";

import playgroundReducers from "./playground";

export default combineReducers({
	playground: playgroundReducers
});
